import { Component, OnInit, inject } from '@angular/core';
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {DataService} from "../../services/data.service";
import {AccessService} from "../../services/access.service";
import {ToastrService} from "ngx-toastr";
import Swal from "sweetalert2";
import {ViewMode} from "../../interfaces";
import {NgForOf, NgIf} from "@angular/common";

@Component({
    selector: 'app-franchisee-detail',
    imports: [NgIf, ReactiveFormsModule, NgForOf, RouterLink],
    template: `
        <div class="card">
            <div class="card-body">
                <div class="mb-4">
                    <h3>
                        <i class="fa-solid fa-handshake me-2"></i>
                        @switch (viewMode) {
                            @case (ViewMode.INSERT) {
                                Franchisenehmer anlegen
                            }
                            @case (ViewMode.EDIT) {
                                Franchisenehmer bearbeiten
                            }
                            @case (ViewMode.VIEW) {
                                Franchisenehmer
                            }
                        }
                    </h3>
                </div>

                <form [formGroup]="form">
                    <!-- Zuordnung -->
                    <h5 class="mt-2">Zuordnung</h5>
                    <div class="row g-3 align-items-end mb-3">
                        <div class="col-12 col-lg-6">
                            <label>Franchisegeber</label>
                            <select class="form-control" formControlName="id_franchisor" *ngIf="viewMode != ViewMode.VIEW">
                                <option value="" disabled selected style="display: none;">Bitte auswählen</option>
                                <option *ngFor="let franchisor of franchisors" [ngValue]="franchisor.id">
                                    {{ franchisor.name }}
                                </option>
                            </select>
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">
                                <a [routerLink]="['/franchisor/', form.value.id_franchisor]">{{ form.value.franchisor }}</a>
                            </p>
                        </div>
                    </div>

                    <!-- Firma -->
                    <h5>Firma</h5>
                    <div class="row g-3 align-items-end mb-3">
                        <div class="col-12 col-lg-4">
                            <label>Firmenname</label>
                            <input type="text" class="form-control" formControlName="name" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.name }}</p>
                        </div>
                        <div class="col-12 col-lg-4">
                            <label>Billing E-Mail</label>
                            <input type="text" class="form-control" formControlName="email_billing" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">
                                @if (form.value.email_billing) { <a (click)="$event.stopPropagation()" [href]="'mailto:' + form.value.email_billing">{{ form.value.email_billing }}</a> }
                                <span class="text-muted" *ngIf="!form.value.email_billing">Nicht gesetzt</span>
                            </p>
                        </div>
                    </div>

                    <!-- Kontakt -->
                    <h5>Kontakt</h5>
                    <div class="row g-3 align-items-end mb-3">
                        <div class="col-12 col-lg-3">
                            <label>Anrede</label>
                            <select class="form-control" formControlName="title" *ngIf="viewMode != ViewMode.VIEW">
                                <option value="" disabled selected style="display: none;">Bitte auswählen</option>
                                <option value="Frau">Frau</option>
                                <option value="Herr">Herr</option>
                            </select>
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">
                                {{ form.value.title }}
                                <span class="text-muted" *ngIf="!form.value.title">Nicht gesetzt</span>
                            </p>
                        </div>
                        <div class="col-12 col-lg-3">
                            <label>Name</label>
                            <input type="text" class="form-control" formControlName="contact" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.contact }}</p>
                        </div>
                        <div class="col-6 col-lg-3">
                            <label>Telefon</label>
                            <input type="text" class="form-control" formControlName="phone" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.phone }}</p>
                        </div>
                        <div class="col-6 col-lg-3">
                            <label>E-Mail</label>
                            <input type="text" class="form-control" formControlName="email" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">
                                @if (form.value.email) { <a (click)="$event.stopPropagation()" [href]="'mailto:' + form.value.email">{{ form.value.email }}</a> }
                                <span class="text-muted" *ngIf="!form.value.email">Nicht gesetzt</span>
                            </p>

                        </div>
                    </div>

                    <!-- Adresse -->
                    <h5>Adresse</h5>
                    <div class="row g-3 align-items-end mb-3">
                        <div class="col-12 col-lg-4">
                            <label>Land</label>
                            <select class="form-control" formControlName="id_country" *ngIf="viewMode != ViewMode.VIEW">
                                <option value="" disabled selected style="display: none;">Bitte auswählen</option>
                                <option *ngFor="let country of countries" [ngValue]="country.id">
                                    {{ country.name }}
                                </option>
                            </select>
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.country }}</p>
                        </div>
                        <div class="col-6 col-lg-2">
                            <label>PLZ</label>
                            <input type="text" class="form-control" formControlName="zip" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.zip }}</p>
                        </div>
                        <div class="col-6 col-lg-3">
                            <label>Ort</label>
                            <input type="text" class="form-control" formControlName="city" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.city }}</p>
                        </div>
                        <div class="col-12 col-lg-3">
                            <label>Straße</label>
                            <input type="text" class="form-control" formControlName="street" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.street }}</p>
                        </div>
                    </div>

                    <!-- Rechtliches & Steuern -->
                    <h5>Rechtliches & Steuern</h5>
                    <div class="row g-3 align-items-end">
                        <div class="col-12 col-lg-4">
                            <label>Firmenbuchnummer</label>
                            <input type="text" class="form-control" formControlName="register_number" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.register_number }}</p>
                        </div>
                        <div class="col-12 col-lg-4">
                            <label>UID</label>
                            <input type="text" class="form-control" formControlName="vat_number" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.vat_number }}</p>
                        </div>
                        <div class="col-12 col-lg-4">
                            <label>Steuersatz (%)</label>
                            <input type="number" class="form-control" formControlName="tax_rate" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.tax_rate }}</p>
                        </div>
                    </div>
                </form>

                <div class="mt-3 d-flex flex-wrap justify-content-between gap-2">
                    @if (viewMode == ViewMode.VIEW) {
                        <div class="d-flex flex-wrap gap-2">
                            <button type="button" class="btn btn-primary" (click)="setMode(ViewMode.EDIT)">Bearbeiten</button>
                            <button type="button" class="btn btn-secondary" (click)="cancel()">Zurück</button>
                            <button type="button" class="btn btn-danger" (click)="delete()" [disabled]="franchisee?.stores != '0'">Löschen</button>
                        </div>

                        <div class="d-flex flex-wrap gap-2">
                            @if (!franchisee?.has_user) {
                                <button type="button" class="btn btn-info" (click)="createUser()">Connect Benutzer anlegen</button>
                            }
                            <button type="button" class="btn btn-info" (click)="export()">PDF Export</button>
                        </div>
                    } @else if (viewMode == ViewMode.EDIT) {
                        <div class="d-flex flex-wrap gap-2">
                            <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="update()">Aktualisieren</button>
                            <button type="button" class="btn btn-secondary" (click)="cancelEdit()">Abbrechen</button>
                        </div>
                    } @else if (viewMode == ViewMode.INSERT) {
                        <div class="d-flex flex-wrap gap-2">
                            <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="save()">Speichern</button>
                            <button type="button" class="btn btn-secondary" (click)="cancel()">Abbrechen</button>
                        </div>
                    }
                </div>

            </div>
        </div>
    `
})
export class FranchiseeDetailComponent implements OnInit {

    accessService = inject(AccessService);
    private router = inject(Router);
    private fb = inject(UntypedFormBuilder);
    private dataService = inject(DataService);
    private route = inject(ActivatedRoute);
    private toastrService = inject(ToastrService);

    ViewMode = ViewMode;

    form!: UntypedFormGroup;
    id_franchisee!: string;
    viewMode!: ViewMode;
    franchisee: any;

    countries!: any[];
    franchisors!: any[];

    ngOnInit(): void {
        this.id_franchisee = this.route.snapshot.paramMap.get('id') ?? '0';
        this.viewMode = this.id_franchisee == '0' ? ViewMode.INSERT : ViewMode.VIEW;

        this.form = this.fb.group({
            id: [null],
            id_franchisor: ['', Validators.required],
            id_country: ['', Validators.required],
            name: [null, Validators.required],
            zip: [null, Validators.required],
            city: [null, Validators.required],
            title: ['', Validators.required],
            contact: [null, Validators.required],
            phone: [null, Validators.required],
            email: [null, Validators.required],
            street: [null, Validators.required],
            email_billing: [null, Validators.required],
            register_number: [null, Validators.required],
            vat_number: [null, Validators.required],
            tax_rate: [null, Validators.required],

            franchisor: [null],
            country: [null],
        });

        if (this.id_franchisee !== '0') {
            this.getFranchisee();
        }

        this.dataService.request("Franchisor/listForSelection").subscribe(response => {
            this.franchisors = response.franchisors;
        });

        this.dataService.request("Country/listForSelection").subscribe(response => {
            this.countries = response.countries;
        });
    }

    getFranchisee(): void {
        this.dataService.request('Franchisee/get', {
            id_franchisee: this.id_franchisee
        }).subscribe(response => {
            this.franchisee = response.franchisee;

            this.patchForm();
        });
    }

    patchForm(): void {
        this.form.patchValue({
            id: this.franchisee.id,
            id_franchisor: this.franchisee.id_franchisor,
            id_country: this.franchisee.id_country,
            name: this.franchisee.name,
            zip: this.franchisee.zip,
            city: this.franchisee.city,
            title: this.franchisee.title ?? '',
            contact: this.franchisee.contact,
            phone: this.franchisee.phone,
            email: this.franchisee.email,
            street: this.franchisee.street,
            email_billing: this.franchisee.email_billing,
            register_number: this.franchisee.register_number,
            vat_number: this.franchisee.vat_number,
            tax_rate: this.franchisee.tax_rate,

            franchisor: this.franchisee.franchisor,
            country: this.franchisee.country,
        });
    }

    save(): void {
        this.dataService.request('Franchisee/save', {
            franchisee: this.form.getRawValue(),
        }).subscribe(() => {
            this.router.navigate(['/franchisee']);
            this.toastrService.success('Der Franchisenehmer wurde angelegt');
        });
    }

    update(): void {
        this.dataService.request('Franchisee/update', {
            franchisee: this.form.getRawValue(),
        }).subscribe(() => {
            this.setMode(ViewMode.VIEW);
            this.getFranchisee();
            this.toastrService.success('Der Franchisenehmer wurde aktualisiert');
        });
    }

    cancel(): void {
        this.router.navigate(['/franchisee']);
    }

    setMode(viewMode: ViewMode): void {
        this.viewMode = viewMode;
    }

    cancelEdit(): void {
        this.patchForm();
        this.setMode(ViewMode.VIEW);
        this.getFranchisee();
    }

    delete(): void {
        Swal.fire({
            title: 'Sicher?',
            text: 'Der Franchisenehmer wird gelöscht.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nein'
        }).then(result => {
            if (result.value) {
                this.dataService.request('Franchisee/delete', {
                    id_franchisee: this.id_franchisee
                }).subscribe(() => {
                    this.cancel();
                    this.toastrService.success('Der Franchisenehmer wurde gelöscht');
                });
            }
        });
    }

    export() {
        this.dataService.request("Franchisee/export", {
            id_franchisee: this.id_franchisee
        }).subscribe(response => {
            if (response?.pdf) {
                const byteCharacters = atob(response.pdf);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {type: 'application/pdf'});
                const url = URL.createObjectURL(blob);
                window.open(url, '_blank');
                // Optionally revoke after some delay
                setTimeout(() => URL.revokeObjectURL(url), 60000);
            }
        });
    }

    protected createUser() {
        Swal.fire({
            title: 'Sicher?',
            text: 'Der Connect Benutzer wird angelegt und per E-Mail informiert.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nein'
        }).then(result => {
            if (result.value) {
                this.dataService.request('Franchisee/createUser', {
                    id_franchisee: this.id_franchisee
                }).subscribe(() => {
                    this.getFranchisee();
                    this.toastrService.success('Der Benutzer wurde angelegt');
                });
            }
        });
    }
}
